// MobileHeader — мини-хедер мобильной версии: кошелёк + поиск (+ бренд),
// один функциональный набор в трёх компоновках — лаборатория /test/mobile:
//   gmgn  — аватар слева, поиск-поле во всю ширину, колокольчик
//   brand — козлик слева; справа search-чип + баланс-чип + аватар
//   crew  — ФИНАЛ: аватар слева; справа search-чип, bell-чип, баланс-чип
// Позиционирование решает шелл. В проде (crew) баланс и обработчики приходят
// пропсами из MobileShell; в лаборатории — дефолты, кнопки инертны.

import { GramMark } from '../ui/icons/GramMark'
import { Bell, ChevronDown, Search, Settings, Wallet } from '../ui/icons/app'
import styles from './MobileHeader.module.css'

export type HeaderVariant = 'gmgn' | 'brand' | 'crew' | 'handoff'

interface HeaderProps {
  variant: HeaderVariant
  balance?: string
  avatarLetter?: string
  avatarSrc?: string | null
  hasAlerts?: boolean
  onSearch?: () => void
  onBell?: () => void
  onSettings?: () => void
  onWallet?: () => void
  onProfile?: () => void
  onLogin?: () => void
}

export function MobileHeader({
  variant,
  balance = '20.26',
  avatarLetter = 'K',
  avatarSrc = null,
  hasAlerts = false,
  onSearch,
  onBell,
  onSettings,
  onWallet,
  onProfile,
  onLogin,
}: HeaderProps) {
  const avatar = (
    <button type="button" className={styles.avatar} aria-label="Account" onClick={onProfile}>
      {avatarSrc ? <img src={avatarSrc} alt="" /> : avatarLetter}
    </button>
  )
  const searchChip = (
    <button type="button" className={styles.searchChip} onClick={onSearch}>
      <Search size={15} />
      <span>Search</span>
    </button>
  )
  const balanceChip = (
    <button type="button" className={styles.chip} aria-label="Wallet balance" onClick={onWallet}>
      <Wallet size={15} />
      <GramMark size={13} />
      <span className={styles.chipValue}>{balance}</span>
      <ChevronDown size={11} />
    </button>
  )
  const bellChip = (
    <button type="button" className={styles.bellChip} aria-label="Notifications" onClick={onBell}>
      <Bell size={16} />
    </button>
  )

  return (
    <header className={`${styles.hdr} ${styles[variant]}`}>
      {variant === 'gmgn' && (
        <>
          {avatar}
          <button type="button" className={styles.search} onClick={onSearch}>
            <Search size={16} />
            <span>Token, contract or wallet</span>
          </button>
          <button
            type="button"
            className={styles.iconBtn}
            aria-label="Notifications"
            onClick={onBell}
          >
            <Bell size={19} />
          </button>
        </>
      )}
      {variant === 'brand' && (
        <>
          <button type="button" className={styles.goat} aria-label="wils.trade — Discover">
            <img src="/wils-goat.png" alt="" width={40} height={40} />
          </button>
          <span className={styles.spacer} />
          {searchChip}
          {balanceChip}
          {avatar}
        </>
      )}
      {variant === 'crew' && (
        <>
          {avatar}
          <span className={styles.spacer} />
          {searchChip}
          {bellChip}
          {balanceChip}
        </>
      )}
      {variant === 'handoff' && (
        <>
          <button type="button" className={styles.searchWide} onClick={onSearch}>
            <Search size={15} />
            <span>Token, contract or wallet</span>
          </button>
          <button
            type="button"
            className={styles.plainIcon}
            aria-label="Notifications"
            onClick={onBell}
          >
            <Bell size={21} />
            {hasAlerts ? <span className={styles.alertDot} /> : null}
          </button>
          <button
            type="button"
            className={styles.plainIcon}
            aria-label="Settings"
            onClick={onSettings}
          >
            <Settings size={21} />
          </button>
          {onLogin ? (
            <button type="button" className={styles.loginChip} onClick={onLogin}>
              Log in
            </button>
          ) : null}
        </>
      )}
    </header>
  )
}
